import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';
import { agreementStore, locationStore, languageStore, LocationInterface, AgreementInterface, userStore } from 'stores';
import TableHeader from 'components/Table/TableHeader';
import { required } from 'helpers/FormValidation';
import DetailsPage from '../DetailsPage';
import * as _ from 'lodash';
import { ModalColumn } from 'components/Modal';
import ContractDetailsItem from 'components/ContractDetailsItem';
import Location from 'components/Forms/Location';

@observer class AgreementPage extends React.Component {

    form = new FormState({
        id: new FieldState<null | string>(null),
        name: new FieldState(null).validators(required),
        locationId: new FieldState(null).validators(required)
    })

    componentDidMount() {
        const companyId = userStore.signedInUser.company.id;
        locationStore.getLocationsByCompany(companyId);

        agreementStore.getAgreements();
    }

    onDeleteAgreement = async (agreementId: string) => {
        const agree = _.find(agreementStore.agreements, { id: agreementId }) as AgreementInterface;
        const locationId = agree.locationId;

        await agreementStore.deleteAgreement(locationId, agreementId);
    }

    render() {
        const data = agreementStore.agreements || [];
        const locations = locationStore.locations || [];
        const form = this.form.$;
        const isNewEntity = !!!form.id.$;

        const columns = [
            {
                Header: <TableHeader value={languageStore.get('name')} />,
                accessor: 'name'
            },
            {
                Header: <TableHeader value={languageStore.get('location')} />,
                id: 'locationId',
                accessor: (d: any) => {
                    const loc = _.find(locations, { id: d.locationId }) as LocationInterface;
                    return loc ? loc.name : '-';
                }
            },
        ]

        return (
            <DetailsPage
                fullWidth={true}
                generalTitle={languageStore.get('agreements')}
                modalTitle={languageStore.get('agreements')}
                form={this.form}
                onUpdate={(agreement: AgreementInterface) => agreementStore.updateAgreement(agreement)}
                onSubmit={(agreement: AgreementInterface) => agreementStore.createAgreement(agreement)}
                onDelete={(id: string) => this.onDeleteAgreement(id)}
                collection={data}
                columns={columns}>

                <ModalColumn>

                    <ContractDetailsItem
                        fieldState={form.name}
                        label={languageStore.get('name')}
                        id='name'
                        editMode={true} />

                    {
                        isNewEntity &&
                        <Location fieldState={form.locationId} editMode={true} />
                    }

                </ModalColumn>

            </DetailsPage>
        )
    }

}

export default AgreementPage;